import { cssToken } from '@youhelp-ru/ui';
import { RangeTokens, SetOfRangeTokens } from './types';

export const RANGE_INPUT_DEFAULT_STEP = 1;
export const RANGE_INPUT_DEFAULT_MIN = 0;
export const RANGE_INPUT_DEFAULT_MAX = 20;

export const RANGE_FILTER_EDGE_DISABLED_OPACITY = 0.5;

const TokenScope = 'range_input';

export const CssTokensOfRange: RangeTokens = {
  SliderLabelBackground: cssToken(TokenScope, ['slider', 'label', 'background']),
  SliderThumbBorderWidth: cssToken(TokenScope, ['slider', 'thumb', 'border', 'width']),
  SliderThumbSize: cssToken(TokenScope, ['slider', 'thumb', 'slider']),
  SliderTrackHeight: cssToken(TokenScope, ['slider', 'track', 'height']),
};

export const DefaultSetOfRangeTokens: SetOfRangeTokens = {
  [CssTokensOfRange.SliderThumbBorderWidth]: '2px',
  [CssTokensOfRange.SliderThumbSize]: '16px',
  [CssTokensOfRange.SliderTrackHeight]: '2px',
};

export const LargeSetOfRangeTokens: SetOfRangeTokens = {
  [CssTokensOfRange.SliderThumbBorderWidth]: '3px',
  [CssTokensOfRange.SliderThumbSize]: '30px',
  [CssTokensOfRange.SliderTrackHeight]: '6px',
};
